import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import type { CreateShareRequestRequest, ShareRequestTaskResponse } from '../../../../shared/types/routes/sbomShare';

import { getShareRequestsQueryKey } from './useGetShareRequests';
/**
 * Function to create a new share request for a revision
 */
async function createShareRequest(data: CreateShareRequestRequest) {
  const response = await post<CreateShareRequestRequest, ShareRequestTaskResponse >('/api/v1/share-requests', data);
  return response.data;
}

/**
 * Hook for creating a new share request
 */
export default function useCreateShareRequest(projectLocator: string) {
  return useToastedMutation({
    mutationFn: createShareRequest,
    successToastMessage: () => 'Share request created successfully.',
    errorToastMessage: 'Failed to create share request.',
    onSuccess: () => {
      // Invalidate relevant queries
      queryClient.invalidateQueries(getShareRequestsQueryKey(projectLocator));
    },
  });
}
